($ => {
  document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', function(event) {
    waitForElem('#product-builder .charm-step .cpb-category-title', (title) => {
      charmSearchBar.init(title);
    });
    // charmSearchBar.init()
  });

  const waitForElem = (selector, callback, parent) => {
    const check = () => {
      let el;
      if (!parent) {
        el = document.querySelector(selector);
      } else {
        el = parent.querySelector(selector);
      }
      if (el) {
        callback(el);
        return true;
      }
      return false;
    };
    if (!check()) {
      const interval = setInterval(() => {
        if (check()) clearInterval(interval);
      }, 200);
    }
  };

  const charmSearchBar = {
    builder: $('#product-builder'),
    input: $('<input class="cpbc-charm-search__input" name="charm-search-query" placeholder="Search charms" />'),
    charmsData: null,
    search(query) {
      const resIndexes = [];
      const regExp = new RegExp('(' + query.toLowerCase().trim().replaceAll(/\s+/g, ' ').split(' ').join(')|(') + ')');
      this.charmsData.forEach((label, i) => {
        if (regExp.test(label)) {
          resIndexes.push(i);
        }
      });
      return resIndexes;
    },
    inputEventHandler(e) {
      const query = e.currentTarget.value;
      const charmSteps = document.querySelectorAll('.charm-step');
      const charmOptions = document.querySelectorAll('.charm-step .option-type-img');
      const isEmpty = query == '' ? true : false;
      
      if (isEmpty) return charmOptions.forEach(c => c.classList.remove('cpb-hide'));

      charmOptions.forEach(c => c.classList.add('cpb-hide'));
      const results = this.search(query);
      document.querySelectorAll('.charm-step').forEach(step => {
        results.forEach(resIndex => {
          step.querySelectorAll('.option-type-img')[resIndex].classList.remove('cpb-hide');          
        });
      });
    },
    changeStepHandler(e) {
      const charmSteps = document.querySelectorAll('.charm-step');
      const activeCharmStep = [...charmSteps].find(s => s.checkVisibility());
      waitForElem('.cpb-category-title', (title) => {
        title.insertAdjacentElement('afterend', this.input[0]);
      }, activeCharmStep)
    },
    init(title) {      
      this.charmsData = (() => {
        const data = [];
        CPB.getStore().getState().Product.panels.find(p => p.extraClassName === 'charm-step').categories[0].options.forEach(option => {
          let label = option.option.data.label.toLowerCase();
          const keyWords = option.metafields?.find(mf => mf.key == 'key-words')?.value;
          if (keyWords) label+= ' ' + keyWords;
          data.push(label);
        });
        return data;
      })();

      title.insertAdjacentElement('afterend', this.input[0]);
      this.input[0].addEventListener('input', this.inputEventHandler.bind(this));
      document.body.addEventListener('CPB_ON_UPDATE_CURRENT_TAB', this.changeStepHandler.bind(this));
      this.builder.attr('cpbc-charm-search', 'true');
    }
  }
})(jQuery)